import { gql } from 'graphql-request'

export const createEquipmentAssignment = gql`
  mutation CreateEquipmentAssignment($input: CreateEquipmentAssignmentInput!) {
    createEquipmentAssignment(input: $input) {
      id
      equipmentId
      clientId
      checkInId
      delayMinutes
      timerMinutes
      status
      assignedAt
      doneAt
      cancelledAt
      createdAt
      updatedAt
      addOnAmount
      addOnInvoiceId
    }
  }
`

export const cancelEquipmentAssignment = gql`
  mutation CancelEquipmentAssignment($assignmentId: String!) {
    cancelEquipmentAssignment(assignmentId: $assignmentId) {
      id
    }
  }
`
